import { classes } from 'html-classes';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';

import { company } from '~/company/Company';
import Icon from '~/components/Icon/Icon';
import Modal from '~/components/Modal/Modal';
import { useGlobal } from '~/hooks/useGlobal';
import { useModal } from '~/hooks/useModal';

import styles from './ReferralProgram.module.scss';

export const ReferralProgramModal = () => {
  const { t } = useTranslation();
  const { isMobile } = useGlobal();
  const navigate = useNavigate();
  const { closeModal } = useModal();

  useEffect(() => {
    if (isMobile) {
      navigate('/cabinet/referral');
    }
  }, [isMobile, navigate, open]);

  return (
    <Modal isShow={true} onBackdropDismiss={() => closeModal()}>
      <div className={styles.modal}>
        <button
          onClick={() => closeModal()}
          className={classes(['button _no-padding', styles.close])}
        >
          <Icon type="close" size={32} />
        </button>
        <div className={styles.block}>
          <p className={styles.title}>{t('shareLove')}</p>
          <p className={styles.description}>{t('referFriend')}</p>
          <Link
            to="/cabinet/referral"
            className={classes(['button _primary', styles.action])}
          >
            {t('inviteFriendsNow')}
          </Link>
        </div>
        <img
          src={company.images.referral.hero || ''}
          alt=""
          className={styles.image}
        />
      </div>
    </Modal>
  );
};
